import { c as _c } from "react/compiler-runtime";
import { CONTACTS_IMPORT_API } from 'modules/contacts/contacts-import/api/contacts-import-api';
import { ContactsImportFilterInterface, ContactsLastImportsApiInterface } from 'modules/contacts/contacts-import/types/contacts-import-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { SwrPaginationInterface } from 'shared/types/pagination-interface';
import useSWR from 'swr';
export interface ContactPageSwrInterface extends SwrPaginationInterface {
  filter: ContactsImportFilterInterface;
}
export function useLastContactsImports(t0) {
  const $ = _c(10);
  const {
    limit,
    pagination,
    filter
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const filterApi = `${filter.date[0] ? `&filter[dateSince]=${filter.date[0]}` : ""}${filter.date[1] ? `&filter[dateTill]=${filter.date[1]}` : ""}`;
  let t2;
  if ($[1] !== filterApi || $[2] !== limit || $[3] !== pagination || $[4] !== user) {
    t2 = () => {
      if (user && limit) {
        if (pagination.startFromId) {
          return `${CONTACTS_IMPORT_API}?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`;
        } else {
          return `${CONTACTS_IMPORT_API}?pagination[limit]=${limit}${filterApi}`;
        }
      } else {
        return null;
      }
    };
    $[1] = filterApi;
    $[2] = limit;
    $[3] = pagination;
    $[4] = user;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: lastContactsImports,
    mutate: mutateLastContactsImports,
    isValidating: isLastContactsImportsValidating
  } = useSWR(t2, fetcher);
  let t3;
  if ($[6] !== isLastContactsImportsValidating || $[7] !== lastContactsImports || $[8] !== mutateLastContactsImports) {
    t3 = {
      lastContactsImports,
      isLastContactsImportsValidating,
      mutateLastContactsImports
    };
    $[6] = isLastContactsImportsValidating;
    $[7] = lastContactsImports;
    $[8] = mutateLastContactsImports;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}